import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { spinnerTheme } from './styles'

const Spinner = ({ theme, variant = 'colored', className }) => (
  <div className={cx(styles.wrapper, className)}>
    <span className={cx(styles.spinner, spinnerTheme(theme, variant))} />
    <span className={cx(styles.spinner, spinnerTheme(theme, variant))} />
    <span className={cx(styles.spinner, spinnerTheme(theme, variant))} />
  </div>
)

Spinner.propTypes = {
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  variant: PropTypes.oneOf(['', 'colored', 'white']),
  className: PropTypes.string,
}

Spinner.defaultProps = {
  theme: 'primary',
}

export default Spinner
